import React from "react";
import PhoneInput from "./PhoneInput";

const FUND_SOURCES = [
  { value: "salary",            label: "Salary / Wages",         description: "Regular employment income" },
  { value: "self_employment",   label: "Self-Employment",         description: "Business or freelance income" },
  { value: "pension",           label: "Pension / Retirement",    description: "Pension or retirement fund distributions" },
  { value: "sale_of_property",  label: "Sale of Property",        description: "Proceeds from a property sale" },
  { value: "investments",       label: "Investments / Dividends", description: "Returns from stocks, bonds, or funds" },
  { value: "bank_loan",         label: "Bank Loan / Mortgage",    description: "Approved financing from a financial institution" },
  { value: "rental_income",     label: "Rental Income",           description: "Income from property you rent out" },
  { value: "family_support",    label: "Family Support",          description: "Financial assistance from family members" },
  { value: "other",             label: "Other",                   description: "Any other source not listed above" },
];

const ReferencesFundsStep = ({
  references,
  sourceOfFunds,
  onReferenceChange,
  onSourceOfFundsChange,
  onSourceToggle,
}) => {
  return (
    <>
      <hr className="my-4" />

      <h5 className="mb-3">References</h5>
      {[0, 1].map((idx) => (
        <div className="border rounded p-3 mb-3" key={idx}>
          <h6 className="mb-3">
            Reference {idx + 1}
            <span className="text-danger ms-1">*</span>
          </h6>
          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label">
                Name <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={references[idx].name}
                onChange={(e) =>
                  onReferenceChange(idx, "name", e.target.value)
                }
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">
                Address <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={references[idx].address}
                onChange={(e) =>
                  onReferenceChange(idx, "address", e.target.value)
                }
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Phone <span className="text-danger">*</span>
              </label>
              <PhoneInput
                value={references[idx].phone}
                onChange={(val) => onReferenceChange(idx, "phone", val)}
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Place of Employment <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={references[idx].placeOfEmployment}
                onChange={(e) =>
                  onReferenceChange(
                    idx,
                    "placeOfEmployment",
                    e.target.value
                  )
                }
                required
              />
            </div>
            <div className="col-md-4">
              <label className="form-label">
                Relationship <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={references[idx].relationship}
                onChange={(e) =>
                  onReferenceChange(
                    idx,
                    "relationship",
                    e.target.value
                  )
                }
                required
              />
            </div>
            <div className="col-md-6">
              <label className="form-label">
                Address of Employment <span className="text-danger">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                value={references[idx].employmentAddress}
                onChange={(e) =>
                  onReferenceChange(
                    idx,
                    "employmentAddress",
                    e.target.value
                  )
                }
                required
              />
            </div>
          </div>
        </div>
      ))}

      <hr className="my-4" />

      <h5 className="mb-1">Source of Funds</h5>
      <p className="text-muted small mb-3">
        Please indicate all sources you intend to use to meet your rental obligations. Select all that apply.
      </p>

      <div className="row g-3">
        {FUND_SOURCES.map(({ value, label, description }) => {
          const checked = sourceOfFunds.sources.includes(value);
          return (
            <div className="col-md-6" key={value}>
              <div
                onClick={() => onSourceToggle(value)}
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "0.75rem",
                  padding: "0.75rem 1rem",
                  borderRadius: "0.5rem",
                  border: checked ? "1.5px solid #0d6efd" : "1.5px solid #dee2e6",
                  backgroundColor: checked ? "#f0f6ff" : "#fff",
                  cursor: "pointer",
                  transition: "border-color 0.15s, background-color 0.15s",
                  userSelect: "none",
                }}
              >
                <input
                  type="checkbox"
                  checked={checked}
                  onChange={() => onSourceToggle(value)}
                  onClick={(e) => e.stopPropagation()}
                  style={{ marginTop: "0.2rem", accentColor: "#0d6efd", flexShrink: 0 }}
                />
                <div>
                  <div style={{ fontWeight: 500, fontSize: "0.875rem", color: "#212529" }}>{label}</div>
                  <div style={{ fontSize: "0.75rem", color: "#6c757d", marginTop: "0.1rem" }}>{description}</div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {sourceOfFunds.sources.includes("other") && (
        <div className="mt-3">
          <label className="form-label fw-semibold">Please describe your other source of funds</label>
          <textarea
            className="form-control"
            rows={2}
            placeholder="Briefly describe the source…"
            value={sourceOfFunds.otherDetails}
            onChange={(e) => onSourceOfFundsChange("otherDetails", e.target.value)}
          />
        </div>
      )}

      <hr className="my-4" />

      <h5 className="mb-3">Declaration</h5>
      <p className="small text-muted">
        By submitting this application you confirm that the information
        provided is accurate and may be used to determine your credit and
        employment history, similar to the declaration on the paper rental
        application form.
      </p>
    </>
  );
};

export default ReferencesFundsStep;
